// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FeedbackModule_wrapper__1HqZi","content":"FeedbackModule_content__2yZ1E"};